/* ==========================================================================
   GloviaSkin — shared section behaviour
   Idempotent and re-runnable, so Shopify's theme editor can reload sections
   without stacking duplicate observers or animation frames.
   ========================================================================== */

(function () {
  'use strict';

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Scroll reveal ----------------------------------------------------- */

  var revealObserver = null;

  function getRevealObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;

    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('gs-in');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );

    return revealObserver;
  }

  function initReveals(root) {
    var els = root.querySelectorAll('.gs-reveal:not([data-gs-revealed])');
    var observer = getRevealObserver();

    els.forEach(function (el) {
      el.setAttribute('data-gs-revealed', 'true');
      if (reducedMotion || !observer) {
        el.classList.add('gs-in');
      } else {
        observer.observe(el);
      }
    });
  }

  /* --- Parallax ---------------------------------------------------------- */

  var parallaxEls = [];
  var parallaxTicking = false;

  function applyParallax() {
    var y = window.scrollY;

    parallaxEls.forEach(function (el) {
      if (!el.isConnected) return;
      var speed = parseFloat(el.getAttribute('data-gs-speed') || '0.1');
      var centered = el.hasAttribute('data-gs-centered');
      el.style.transform =
        (centered ? 'translate(-50%, -50%) ' : '') + 'translateY(' + y * speed + 'px)';
    });

    parallaxTicking = false;
  }

  function onParallaxScroll() {
    if (parallaxTicking) return;
    parallaxTicking = true;
    window.requestAnimationFrame(applyParallax);
  }

  function initParallax(root) {
    if (reducedMotion) return;

    root.querySelectorAll('.gs-parallax:not([data-gs-parallax-bound])').forEach(function (el) {
      el.setAttribute('data-gs-parallax-bound', 'true');
      parallaxEls.push(el);
    });

    parallaxEls = parallaxEls.filter(function (el) {
      return el.isConnected;
    });

    applyParallax();
  }

  /* --- Smooth scroll triggers -------------------------------------------- */

  function initScrollTriggers(root) {
    root.querySelectorAll('[data-gs-scroll-to]:not([data-gs-scroll-bound])').forEach(function (el) {
      el.setAttribute('data-gs-scroll-bound', 'true');
      el.addEventListener('click', function () {
        var selector = el.getAttribute('data-gs-scroll-to');
        if (!selector) return;
        var target = document.querySelector(selector);
        if (target) {
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
        }
      });
    });
  }

  /* --- Hero ripple canvas ------------------------------------------------ */

  function initHeroCanvas(root) {
    root.querySelectorAll('[data-gs-hero-canvas]:not([data-gs-canvas-bound])').forEach(function (canvas) {
      if (!canvas.getContext) return;
      canvas.setAttribute('data-gs-canvas-bound', 'true');

      var ctx = canvas.getContext('2d');
      var frame = null;
      var t = 0;

      function resize() {
        var ratio = window.devicePixelRatio || 1;
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      }

      function draw() {
        if (!canvas.isConnected) {
          if (frame) cancelAnimationFrame(frame);
          return;
        }

        t += 0.006;

        var w = canvas.offsetWidth;
        var h = canvas.offsetHeight;
        var cx = w * 0.6;
        var cy = h * 0.45;

        ctx.clearRect(0, 0, w, h);

        for (var i = 0; i < 4; i++) {
          var r = (Math.sin(t + i) * 0.5 + 0.5) * Math.max(w, h) * 0.35 + i * 40;
          ctx.beginPath();
          ctx.arc(cx, cy, r, 0, Math.PI * 2);
          ctx.strokeStyle = 'rgba(232, 199, 147, ' + (0.14 - i * 0.02) + ')';
          ctx.lineWidth = 1.5;
          ctx.stroke();
        }

        if (!reducedMotion) frame = requestAnimationFrame(draw);
      }

      resize();
      window.addEventListener('resize', resize, { passive: true });
      draw();
    });
  }

  /* --- Boot -------------------------------------------------------------- */

  function init(root) {
    var scope = root || document;
    initReveals(scope);
    initParallax(scope);
    initScrollTriggers(scope);
    initHeroCanvas(scope);
  }

  window.addEventListener('scroll', onParallaxScroll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.GloviaSkin = { init: init };
})();
